// Simple Google Analytics tracking utility
declare global {
  interface Window {
    gtag: (...args: any[]) => void
  }
}

// Track XHR requests
const trackXHR = () => {
  if (typeof window === 'undefined') return

  const originalXHR = window.XMLHttpRequest
  const originalFetch = window.fetch

  // Override XMLHttpRequest
  ;(window as any).XMLHttpRequest = function () {
    const xhr = new originalXHR()
    const originalOpen = xhr.open
    const originalSend = xhr.send

    xhr.open = function (method: string, url: string | URL, ...args: any[]) {
      ;(xhr as any)._method = method
      ;(xhr as any)._url = url
      return (originalOpen as any).apply(xhr, [method, url, ...args])
    }

    xhr.send = function (...args: any[]) {
      const startTime = Date.now()

      xhr.addEventListener('load', () => {
        const duration = Date.now() - startTime
        analytics.event('xhr_request', {
          method: (xhr as any)._method,
          url: (xhr as any)._url,
          status: xhr.status,
          duration: duration,
        })
      })

      return (originalSend as any).apply(xhr, args)
    }

    return xhr
  }

  // Copy static properties
  Object.setPrototypeOf((window as any).XMLHttpRequest, originalXHR)
  ;(window as any).XMLHttpRequest.prototype = originalXHR.prototype

  // Override fetch
  window.fetch = function (input: RequestInfo | URL, init?: RequestInit) {
    const startTime = Date.now()
    const method = init?.method || 'GET'
    const url = typeof input === 'string' ? input : input.toString()

    return originalFetch(input, init).then(response => {
      const duration = Date.now() - startTime
      analytics.event('fetch_request', {
        method: method,
        url: url,
        status: response.status,
        duration: duration,
      })
      return response
    })
  }
}

export const analytics = {
  // Track page views
  pageView: (url?: string) => {
    if (typeof window !== 'undefined' && window.gtag) {
      const path = url || window.location.pathname + window.location.search

      window.gtag('config', 'G-NHXP5W66K5', {
        page_path: path,
      })
    }
  },

  // Track events
  event: (eventName: string, parameters?: Record<string, any>) => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', eventName, parameters)
    }
  },

  // Initialize XHR tracking
  enableXHRTracking: () => {
    trackXHR()
  },
}
